var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBgBodyDesktop = function SvgBgBodyDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    viewBox: "0 0 1440 1100"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bg-body-desktop_svg__a)",
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 709,
    cy: 454.47,
    fill: "url(#bg-body-desktop_svg__b)",
    rx: 641,
    ry: 113.677
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bg-body-desktop_svg__c)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 709,
    cy: 209.501,
    rx: 641,
    ry: 243.647
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bg-body-desktop_svg__d)",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 747.589,
    cy: 500.468,
    fill: "url(#bg-body-desktop_svg__e)",
    rx: 447.589,
    ry: 320.532
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "bg-body-desktop_svg__a",
    width: 1882,
    height: 907.354,
    x: -232,
    y: 0.793,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_274_9177",
    stdDeviation: 150
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bg-body-desktop_svg__c",
    width: 1882,
    height: 1167.29,
    x: -232,
    y: -374.146,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_274_9180",
    stdDeviation: 150
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bg-body-desktop_svg__d",
    width: 1495.18,
    height: 1321.06,
    x: 0,
    y: -160.065,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_274_9179",
    stdDeviation: 150
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg-body-desktop_svg__b",
    x1: 709,
    x2: 709,
    y1: 300.793,
    y2: 608.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1B93B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#FA8435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#FF6932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg-body-desktop_svg__e",
    x1: 747.589,
    x2: 747.589,
    y1: 139.935,
    y2: 861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1B93B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#FA8435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#FF6932"
  })))));
};
export default SvgBgBodyDesktop;